import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';

export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <motion.div
      className="fixed top-0 left-0 right-0 z-[200] origin-left pointer-events-none"
      style={{
        height: '1px',
        scaleX,
        background: 'linear-gradient(90deg, #8a7248, #b89d6a, #d4bc8e)',
      }}
    />
  );
}
